import { useEffect, useState } from 'react'

import { EVENT_NAME_RESIZE } from '../constants/event'
import { Screen } from '../context'
import { getScreenState } from '../utils/screen'

function ScreenProvider({ children }) {
  const [state, setState] = useState(() => {
    return getScreenState()
  })

  useEffect(() => {
    function handleResize() {
      setState(getScreenState)
    }

    window.addEventListener(EVENT_NAME_RESIZE, handleResize)

    return () => {
      window.removeEventListener(EVENT_NAME_RESIZE, handleResize)
    }
  }, [])

  return <Screen value={state}>{children}</Screen>
}

export default ScreenProvider
